import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, scopeQuery, useScope, type Scope } from "../api";
import { useT } from "../i18n";
import { CustomAnnouncementCard, CustomAnnouncementDialog, type CustomAnnouncement } from "./CustomAnnouncementDialog";

/** Custom church announcements (feed + push/email), separate from the automatic matrix. */
export function NotificationOthers() {
  const scope = useScope();
  if (scope.canPickScope && !scope.churchId) {
    return <NotificationOthersNoChurch />;
  }
  return <NotificationOthersInner scope={scope} />;
}

function NotificationOthersNoChurch() {
  const { t } = useT();
  return (
    <section className="panel">
      <h2>{t("admin.notifications.tabOthers")}</h2>
      <p className="muted">{t("admin.fams.noChurch")}</p>
    </section>
  );
}

function NotificationOthersInner({ scope }: { scope: Scope }) {
  const { t, locale } = useT();
  const qc = useQueryClient();
  const sq = scopeQuery(scope, "church");
  const [customOpen, setCustomOpen] = useState(false);

  const customQ = useQuery({
    queryKey: ["admin", "customAnnouncements", scope.churchId],
    queryFn: () => api<{ announcements: CustomAnnouncement[] }>(`/admin/notifications/custom-announcements${sq}`),
  });

  return (
    <section className="panel notification-matrix-others">
      <h2>{t("admin.notifications.automatic.othersTitle")}</h2>
      <p className="muted">{t("admin.notifications.automatic.othersHint")}</p>
      <div className="notification-custom-list">
        {customQ.data?.announcements.map((item) => (
          <CustomAnnouncementCard key={item.id} item={item} locale={locale} />
        ))}
      </div>
      <button type="button" className="btn ghost notification-matrix-others-btn" onClick={() => setCustomOpen(true)}>
        {t("admin.notifications.automatic.othersCreate")}
      </button>
      {customOpen ? (
        <CustomAnnouncementDialog
          onClose={() => setCustomOpen(false)}
          onCreated={() => void qc.invalidateQueries({ queryKey: ["admin", "customAnnouncements", scope.churchId] })}
        />
      ) : null}
    </section>
  );
}
